// extracted by mini-css-extract-plugin
export default {"Box":"issue-type-renderer-module__Box--LmlsQ","Token":"issue-type-renderer-module__Token--nmN83"};